/* Plastara v16 — gold FX layer, dependency-free */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var body = document.body;
  var fxOn = body.getAttribute('data-animations') !== 'false' && !reduced;

  /* ---------- Scroll reveal ---------- */
  var targets = document.querySelectorAll('.reveal, .reveal-stagger, .reveal-wipe, .hero');
  if (fxOn && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12 });
    targets.forEach(function (t) { io.observe(t); });
  } else {
    targets.forEach(function (t) { t.classList.add('is-visible'); });
  }

  /* ---------- Scroll progress bar ---------- */
  var progress = document.querySelector('.scroll-progress');
  if (progress) {
    var onScrollBar = function () {
      var h = document.documentElement;
      var max = h.scrollHeight - h.clientHeight;
      progress.style.width = (max > 0 ? (h.scrollTop / max) * 100 : 0) + '%';
    };
    window.addEventListener('scroll', onScrollBar, { passive: true });
    onScrollBar();
  }

  /* ---------- Gold particles (hero) ---------- */
  var canvas = document.querySelector('.hero__particles');
  if (canvas && fxOn) {
    var ctx = canvas.getContext('2d');
    var particles = [];
    var running = true;

    function resize() {
      canvas.width = canvas.offsetWidth;
      canvas.height = canvas.offsetHeight;
    }
    resize();
    window.addEventListener('resize', resize);

    var count = Math.min(70, Math.floor(canvas.width / 22));
    for (var i = 0; i < count; i++) {
      particles.push({
        x: Math.random() * canvas.width,
        y: Math.random() * canvas.height,
        r: Math.random() * 1.8 + 0.4,
        vy: Math.random() * 0.35 + 0.08,
        vx: (Math.random() - 0.5) * 0.15,
        a: Math.random() * 0.55 + 0.15,
        tw: Math.random() * Math.PI * 2
      });
    }

    function tick() {
      if (!running) return;
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      particles.forEach(function (p) {
        p.y -= p.vy;
        p.x += p.vx;
        p.tw += 0.03;
        if (p.y < -6) { p.y = canvas.height + 6; p.x = Math.random() * canvas.width; }
        if (p.x < -6) p.x = canvas.width + 6;
        if (p.x > canvas.width + 6) p.x = -6;
        var alpha = p.a * (0.6 + 0.4 * Math.sin(p.tw));
        ctx.beginPath();
        ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
        ctx.fillStyle = 'rgba(220, 189, 122, ' + alpha.toFixed(3) + ')';
        ctx.shadowColor = 'rgba(198, 165, 92, 0.8)';
        ctx.shadowBlur = 6;
        ctx.fill();
      });
      requestAnimationFrame(tick);
    }
    tick();

    document.addEventListener('visibilitychange', function () {
      running = !document.hidden;
      if (running) tick();
    });
  }

  /* ---------- Count-up stats ---------- */
  var counters = document.querySelectorAll('[data-count-to]');
  if (counters.length) {
    var runCount = function (el) {
      var to = parseFloat(el.getAttribute('data-count-to')) || 0;
      var suffix = el.getAttribute('data-count-suffix') || '';
      var prefix = el.getAttribute('data-count-prefix') || '';
      if (!fxOn) { el.textContent = prefix + to + suffix; return; }
      var start = null;
      var dur = 1600;
      function step(ts) {
        if (!start) start = ts;
        var p = Math.min((ts - start) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = prefix + Math.round(to * eased) + suffix;
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    };
    if ('IntersectionObserver' in window) {
      var cio = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { runCount(e.target); cio.unobserve(e.target); }
        });
      }, { threshold: 0.4 });
      counters.forEach(function (c) { cio.observe(c); });
    } else {
      counters.forEach(runCount);
    }
  }

  /* ---------- Countdown ---------- */
  document.querySelectorAll('[data-countdown]').forEach(function (root) {
    var end = new Date(root.getAttribute('data-countdown')).getTime();
    if (isNaN(end)) return;
    var els = {
      d: root.querySelector('[data-cd-days]'),
      h: root.querySelector('[data-cd-hours]'),
      m: root.querySelector('[data-cd-mins]'),
      s: root.querySelector('[data-cd-secs]')
    };
    function pad(n) { return n < 10 ? '0' + n : '' + n; }
    function update() {
      var diff = Math.max(0, end - Date.now());
      var d = Math.floor(diff / 86400000);
      var h = Math.floor(diff / 3600000) % 24;
      var m = Math.floor(diff / 60000) % 60;
      var s = Math.floor(diff / 1000) % 60;
      if (els.d) els.d.textContent = pad(d);
      if (els.h) els.h.textContent = pad(h);
      if (els.m) els.m.textContent = pad(m);
      if (els.s) els.s.textContent = pad(s);
      if (diff > 0) setTimeout(update, 1000);
    }
    update();
  });

  /* ---------- Back to top ---------- */
  var backTop = document.querySelector('.back-top');
  if (backTop) {
    window.addEventListener('scroll', function () {
      backTop.classList.toggle('is-visible', window.scrollY > 600);
    }, { passive: true });
    backTop.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: reduced ? 'auto' : 'smooth' });
    });
  }

  /* ---------- Product gallery thumbnails ---------- */
  var mainImage = document.querySelector('[data-main-image]');
  if (mainImage) {
    document.querySelectorAll('[data-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var src = btn.getAttribute('data-src');
        var srcset = btn.getAttribute('data-srcset');
        if (src) mainImage.src = src;
        if (srcset) mainImage.srcset = srcset;
        document.querySelectorAll('[data-thumb]').forEach(function (b) {
          b.classList.remove('is-active');
        });
        btn.classList.add('is-active');
      });
    });
  }

  /* ---------- Variant select ---------- */
  var variantSelect = document.querySelector('[data-variant-select]');
  if (variantSelect) {
    var priceEl = document.querySelector('[data-price]');
    var stickyPrice = document.querySelector('[data-sticky-price]');
    var addBtn = document.querySelector('[data-add-to-cart]');
    variantSelect.addEventListener('change', function () {
      var opt = variantSelect.options[variantSelect.selectedIndex];
      if (priceEl && opt.dataset.price) priceEl.innerHTML = opt.dataset.price;
      if (stickyPrice && opt.dataset.price) stickyPrice.innerHTML = opt.dataset.price;
      if (addBtn) {
        var available = opt.dataset.available === 'true';
        addBtn.disabled = !available;
        addBtn.textContent = available ? addBtn.dataset.labelAdd : addBtn.dataset.labelSoldout;
      }
    });
  }

  /* ---------- Sticky add-to-cart (mobile) ---------- */
  var stickyBar = document.querySelector('.sticky-atc');
  var buyAnchor = document.querySelector('[data-buy-anchor]');
  if (stickyBar && buyAnchor && 'IntersectionObserver' in window) {
    var sio = new IntersectionObserver(function (entries) {
      stickyBar.classList.toggle('is-visible', !entries[0].isIntersecting);
    }, { threshold: 0 });
    sio.observe(buyAnchor);
    var stickyBtn = stickyBar.querySelector('[data-sticky-buy]');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        buyAnchor.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'center' });
      });
    }
  }

  /* ---------- Cart quantity auto-submit ---------- */
  document.querySelectorAll('[data-cart-qty]').forEach(function (input) {
    input.addEventListener('change', function () {
      var form = input.closest('form');
      if (form) form.submit();
    });
  });
})();

/* ---------- v17 luxury layer ---------- */
(function () {
  'use strict';
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fxOn = document.body.getAttribute('data-animations') !== 'false' && !reduced;
  var goldFx = document.body.getAttribute('data-gold-fx') !== 'false';

  /* Preloader */
  var pre = document.querySelector('.preloader');
  if (pre) {
    var hide = function () { pre.classList.add('is-done'); };
    if (reduced) { hide(); }
    else {
      window.addEventListener('load', function () { setTimeout(hide, 700); });
      setTimeout(hide, 2600); /* hard cap — never trap the visitor */
    }
  }

  /* Split headings into animated words */
  if (fxOn) {
    document.querySelectorAll('[data-split]').forEach(function (el) {
      var frag = document.createDocumentFragment();
      el.childNodes.forEach(function () {}); /* noop guard */
      var nodes = Array.prototype.slice.call(el.childNodes);
      nodes.forEach(function (node) {
        if (node.nodeType === 3) {
          node.textContent.split(/(\s+)/).forEach(function (part) {
            if (/^\s+$/.test(part) || part === '') {
              frag.appendChild(document.createTextNode(' '));
            } else {
              var w = document.createElement('span');
              w.className = 'split-word';
              var inner = document.createElement('span');
              inner.textContent = part;
              w.appendChild(inner);
              frag.appendChild(w);
            }
          });
        } else if (node.nodeType === 1) {
          var w2 = document.createElement('span');
          w2.className = 'split-word';
          var inner2 = document.createElement('span');
          inner2.appendChild(node.cloneNode(true));
          w2.appendChild(inner2);
          frag.appendChild(w2);
        }
      });
      el.innerHTML = '';
      el.appendChild(frag);
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
          });
        }, { threshold: 0.3 });
        io.observe(el);
      } else {
        el.classList.add('is-visible');
      }
    });
  }

  /* Parallax */
  if (fxOn) {
    var pItems = Array.prototype.slice.call(document.querySelectorAll('[data-parallax]'));
    if (pItems.length) {
      var onScroll = function () {
        var vh = window.innerHeight;
        pItems.forEach(function (el) {
          var rate = parseFloat(el.getAttribute('data-parallax')) || 0.1;
          var rect = el.getBoundingClientRect();
          var offset = (rect.top + rect.height / 2 - vh / 2) * rate;
          el.style.transform = 'translateY(' + offset.toFixed(1) + 'px) scale(1.12)';
        });
      };
      window.addEventListener('scroll', function () {
        window.requestAnimationFrame(onScroll);
      }, { passive: true });
      onScroll();
    }
  }

  /* Custom gold cursor */
  if (goldFx && !reduced && window.matchMedia('(pointer: fine)').matches) {
    document.documentElement.classList.add('has-cursor-fx');
    var dot = document.querySelector('.cursor-dot');
    var ring = document.querySelector('.cursor-ring');
    if (dot && ring) {
      var mx = -100, my = -100, rx = -100, ry = -100;
      document.addEventListener('mousemove', function (e) { mx = e.clientX; my = e.clientY; });
      (function loop() {
        rx += (mx - rx) * 0.16;
        ry += (my - ry) * 0.16;
        dot.style.transform = 'translate(' + mx + 'px,' + my + 'px) translate(-50%,-50%)';
        ring.style.transform = 'translate(' + rx.toFixed(1) + 'px,' + ry.toFixed(1) + 'px) translate(-50%,-50%)';
        requestAnimationFrame(loop);
      })();
      document.addEventListener('mouseover', function (e) {
        if (e.target.closest('a, button, [data-thumb], summary, input, select, textarea')) {
          ring.classList.add('is-hover');
        }
      });
      document.addEventListener('mouseout', function (e) {
        if (e.target.closest('a, button, [data-thumb], summary, input, select, textarea')) {
          ring.classList.remove('is-hover');
        }
      });
    }
  }

  /* Header scrolled state */
  var header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', function () {
      header.classList.toggle('is-scrolled', window.scrollY > 40);
    }, { passive: true });
  }
})();

/* ---------- v18 craft layer ---------- */
(function () {
  'use strict';
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fxOn = document.body.getAttribute('data-animations') !== 'false' && !reduced;
  var fine = window.matchMedia('(pointer: fine)').matches;

  /* 3D tilt + glare on product cards */
  if (fxOn && fine) {
    document.documentElement.classList.add('has-tilt');

    document.querySelectorAll('.product-card').forEach(function (card) {
      var media = card.querySelector('.product-card__media');
      if (!media) return;
      var glare = document.createElement('div');
      glare.className = 'card-glare';
      media.appendChild(glare);

      card.addEventListener('mousemove', function (e) {
        var r = media.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width;
        var py = (e.clientY - r.top) / r.height;
        var rx = (0.5 - py) * 9;
        var ry = (px - 0.5) * 9;
        media.style.transform = 'perspective(900px) rotateX(' + rx.toFixed(2) + 'deg) rotateY(' + ry.toFixed(2) + 'deg)';
        glare.style.setProperty('--gx', (px * 100).toFixed(1) + '%');
        glare.style.setProperty('--gy', (py * 100).toFixed(1) + '%');
      });
      card.addEventListener('mouseleave', function () {
        media.style.transform = '';
      });
    });

    /* Zoom-follow on product main image */
    var mainWrap = document.querySelector('.product__main-image');
    if (mainWrap) {
      mainWrap.addEventListener('mousemove', function (e) {
        var r = mainWrap.getBoundingClientRect();
        var img = mainWrap.querySelector('img');
        if (!img) return;
        img.style.setProperty('--zx', (((e.clientX - r.left) / r.width) * 100).toFixed(1) + '%');
        img.style.setProperty('--zy', (((e.clientY - r.top) / r.height) * 100).toFixed(1) + '%');
      });
    }
  }

  /* Nav link flip labels */
  document.querySelectorAll('.site-nav a').forEach(function (a) {
    if (a.querySelector('span')) return;
    var text = a.textContent.trim();
    a.setAttribute('data-hover', '');
    var span = document.createElement('span');
    span.setAttribute('data-text', text);
    span.textContent = text;
    a.textContent = '';
    a.appendChild(span);
  });

  /* Cart count pop when it changes (page load after add) */
  var count = document.querySelector('.site-header__cart-count');
  if (count && fxOn) {
    try {
      var prev = sessionStorage.getItem('plastara_cart_count');
      var now = count.textContent.trim();
      if (prev !== null && prev !== now) {
        count.classList.add('pop');
      }
      sessionStorage.setItem('plastara_cart_count', now);
    } catch (e) { /* storage unavailable — skip */ }
  }
})();
